/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '@angular/core/src/linker/ng_module_factory';
import * as import1 from '../../../public/upgrade/saraV2_app';
import * as import2 from '@angular/common/src/common_module';
import * as import3 from '@angular/core/src/application_module';
import * as import4 from '@angular/platform-browser/src/browser';
import * as import5 from '@angular/upgrade/src/aot/upgrade_module';
import * as import6 from '@angular/forms/src/directives';
import * as import7 from '@angular/forms/src/form_providers';
import * as import8 from '@angular/http/src/http_module';
import * as import9 from '@angular/router/src/router_module';
import * as import10 from '../../../public/upgrade/feature/audit/audit-routing.module';
import * as import11 from '../../../public/upgrade/core/datepicker/datepicker.module';
import * as import12 from '@ngx-translate/core/index';
import * as import13 from '../../../public/upgrade/feature/audit/audit.module';
import * as import14 from '../../../public/upgrade/feature/pickuppointfee/pickup-point-fee-routing.module';
import * as import15 from '../../../public/upgrade/shared/shared.module';
import * as import16 from '../../../public/upgrade/feature/pickuppointfee/pickup-point-fee.module';
import * as import17 from '../../../public/upgrade/core/core.module';
import * as import18 from '../../../public/upgrade/feature/contact/contact-routing.module';
import * as import19 from '../../../public/upgrade/feature/contact/contact.module';
import * as import20 from '../../../public/upgrade/feature/sample-v2/sample-routing.module';
import * as import21 from '../../../public/upgrade/feature/sample-v2/sample.module';
import * as import22 from '../../../public/upgrade/feature/internal-error/internal-error-routing.module';
import * as import23 from '../../../public/upgrade/feature/internal-error/internal-error.module';
import * as import24 from '../../../public/upgrade/feature/home/home-routing.module';
import * as import25 from '../../../public/upgrade/feature/home/home.module';
import * as import26 from '../../../public/upgrade/feature/restrictions/restrictions-routing.module';
import * as import27 from '../../../public/upgrade/feature/restrictions/restrictions.module';
import * as import28 from '../../../public/upgrade/feature/booking/booking-routing.module';
import * as import29 from '../../../public/upgrade/feature/booking/booking.module';
import * as import30 from '../../../public/upgrade/feature/logout/logout-routing.module';
import * as import31 from '../../../public/upgrade/feature/logout/logout.module';
import * as import32 from '../../../public/upgrade/feature/additional/additional-routing.module';
import * as import33 from '../../../public/upgrade/feature/additional/additional.module';
import * as import34 from '../../../public/upgrade/feature/insurance/insurance-routing.module';
import * as import35 from '../../../public/upgrade/feature/insurance/insurance.module';
import * as import36 from '../../../public/upgrade/feature/pointOfSale/point-of-sale-routing.module';
import * as import37 from 'angular2-text-mask/dist/angular2TextMask';
import * as import38 from '../../../public/upgrade/feature/pointOfSale/point-of-sale.module';
import * as import39 from '../../../public/upgrade/feature/additionalPoint/additional-point-routing.module';
import * as import40 from '../../../public/upgrade/feature/additionalPoint/additional-point.module';
import * as import41 from '../../../public/upgrade/feature/ageRange/age-range-routing.module';
import * as import42 from '../../../public/upgrade/feature/ageRange/age-range.module';
import * as import43 from '../../../public/upgrade/feature/carTemplate/car-template-routing.module';
import * as import44 from '../../../public/upgrade/feature/carTemplate/car-template.module';
import * as import45 from '../../../public/upgrade/feature/feature.module';
import * as import46 from 'ngx-cookie/index';
import * as import47 from '@angular/common/src/localization';
import * as import48 from '../../../public/upgrade/core/window-ref';
import * as import49 from '../../../public/upgrade/core/newrelic.service';
import * as import50 from '../../../public/upgrade/url-handling-strategy';
import * as import51 from '@angular/common/src/location/location';
import * as import52 from '../../../public/upgrade/core/error-log.service';
import * as import53 from '../../../public/upgrade/root/toast/notification.service';
import * as import54 from '../../../public/upgrade/root/loading/loading-wheel.service';
import * as import55 from '../../../public/upgrade/core/angular-error-handler';
import * as import56 from '@angular/core/src/application_init';
import * as import57 from '@angular/core/src/testability/testability';
import * as import58 from '@angular/core/src/application_ref';
import * as import59 from '@angular/core/src/linker/compiler';
import * as import60 from '@angular/platform-browser/src/dom/events/hammer_gestures';
import * as import61 from '@angular/platform-browser/src/dom/events/event_manager';
import * as import62 from '@angular/platform-browser/src/dom/shared_styles_host';
import * as import63 from '@angular/platform-browser/src/dom/dom_renderer';
import * as import64 from '@angular/platform-browser/src/security/dom_sanitization_service';
import * as import65 from '@angular/core/src/animation/animation_queue';
import * as import66 from '@angular/core/src/linker/view_utils';
import * as import67 from '@angular/platform-browser/src/browser/title';
import * as import68 from '@angular/forms/src/directives/radio_control_value_accessor';
import * as import69 from '@angular/http/src/backends/browser_xhr';
import * as import70 from '@angular/http/src/base_response_options';
import * as import71 from '@angular/http/src/backends/xhr_backend';
import * as import72 from '@angular/http/src/base_request_options';
import * as import73 from '../../../public/upgrade/core/datepicker/calendar-config';
import * as import74 from '@angular/forms/src/form_builder';
import * as import75 from '../../../public/upgrade/core/authenticate-user.service';
import * as import76 from '@ngx-translate/core/src/translate.store';
import * as import77 from '@ngx-translate/core/src/translate.compiler';
import * as import78 from '@ngx-translate/core/src/translate.parser';
import * as import79 from '@ngx-translate/core/src/missing-translation-handler';
import * as import80 from '@ngx-translate/core/src/translate.service';
import * as import81 from '../../../public/upgrade/root/modal/modal.service';
import * as import82 from '../../../public/upgrade/core/company_a2.service';
import * as import83 from 'ngx-cookie/src/cookie-options-provider';
import * as import84 from '../../../public/upgrade/root/ga/ga.service';
import * as import85 from '../../../public/upgrade/core/session.service';
import * as import86 from '../../../public/upgrade/root/sidebar/sidebar.service';
import * as import87 from '../../../public/upgrade/root/information-modal/information-modal.service';
import * as import88 from '../../../public/upgrade/core/logout.service';
import * as import89 from '../../../public/upgrade/root/background-color/background-color.service';
import * as import90 from '../../../public/upgrade/core/validator.service';
import * as import91 from '../../../public/upgrade/root/form-modal/form-modal.service';
import * as import92 from '../../../public/upgrade/core/contract.service';
import * as import93 from '../../../public/upgrade/core/geo_a2.service';
import * as import94 from '../../../public/upgrade/core/version-check.service';
import * as import95 from '../../../public/upgrade/core/alfred.service';
import * as import96 from '../../../public/upgrade/core/geo-code.service';
import * as import97 from '../../../public/upgrade/root/sara-header/navigation.service';
import * as import98 from '../../../public/upgrade/core/email-validator.service';
import * as import99 from '../../../public/upgrade/core/legal_document_service';
import * as import100 from '../../../public/upgrade/core/contract_states.service';
import * as import101 from '../../../public/upgrade/core/console-logger.service';
import * as import102 from '../../../public/upgrade/feature/home/home.service';
import * as import103 from '../../../public/upgrade/feature/pointOfSale/point-of-sale.service';
import * as import104 from '@angular/router/src/url_tree';
import * as import105 from '@angular/router/src/router_outlet_map';
import * as import106 from '@angular/core/src/linker/system_js_ng_module_factory_loader';
import * as import107 from '@angular/router/src/router_preloader';
import * as import108 from '@angular/core/src/di/injector';
import * as import109 from './feature/audit/audit.component.ngfactory';
import * as import110 from './feature/pickuppointfee/list/pickup-point-fee-list.component.ngfactory';
import * as import111 from './feature/pickuppointfee/edit/pickup-point-fee-edit.component.ngfactory';
import * as import112 from './feature/contact/contact.component.ngfactory';
import * as import113 from './feature/sample-v2/sample.component.ngfactory';
import * as import114 from './feature/internal-error/internal-error.component.ngfactory';
import * as import115 from './feature/home/home.component.ngfactory';
import * as import116 from './feature/restrictions/restrictions.component.ngfactory';
import * as import117 from './feature/booking/booking.component.ngfactory';
import * as import118 from './feature/booking/detail/booking-detail.component.ngfactory';
import * as import119 from './feature/logout/logout.component.ngfactory';
import * as import120 from './feature/additional/additional-edit.component.ngfactory';
import * as import121 from './feature/insurance/insurance-edit.component.ngfactory';
import * as import122 from './feature/pointOfSale/edit/point-of-sale-edit.component.ngfactory';
import * as import123 from './feature/additionalPoint/edit/additional-point-edit.component.ngfactory';
import * as import124 from './feature/ageRange/age-range.component.ngfactory';
import * as import125 from './feature/carTemplate/moderate/car-template-moderate.component.ngfactory';
import * as import126 from './feature/carTemplate/list/car-template-list.component.ngfactory';
import * as import127 from './feature/carTemplate/edit/car-template-edit.component.ngfactory';
import * as import128 from './root.component.ngfactory';
import * as import129 from '@angular/core/src/i18n/tokens';
import * as import130 from '@angular/core/src/application_tokens';
import * as import131 from '@angular/platform-browser/src/dom/events/dom_events';
import * as import132 from '@angular/platform-browser/src/dom/events/key_events';
import * as import133 from '@angular/core/src/zone/ng_zone';
import * as import134 from '@angular/platform-browser/src/dom/debug/ng_probe';
import * as import135 from '@angular/upgrade/src/aot/angular1_providers';
import * as import136 from '../../../public/upgrade/feature/audit/audit.component';
import * as import137 from '../../../public/upgrade/feature/pickuppointfee/list/pickup-point-fee-list.component';
import * as import138 from '../../../public/upgrade/feature/pickuppointfee/edit/pickup-point-fee-edit.component';
import * as import139 from '../../../public/upgrade/feature/contact/contact.component';
import * as import140 from '../../../public/upgrade/feature/sample-v2/sample.component';
import * as import141 from '../../../public/upgrade/feature/internal-error/internal-error.component';
import * as import142 from '../../../public/upgrade/feature/home/home.component';
import * as import143 from '../../../public/upgrade/feature/restrictions/restrictions.component';
import * as import144 from '../../../public/upgrade/feature/booking/booking.component';
import * as import145 from '../../../public/upgrade/feature/booking/detail/booking-detail.component';
import * as import146 from '../../../public/upgrade/feature/logout/logout.component';
import * as import147 from '../../../public/upgrade/feature/additional/additional-edit.component';
import * as import148 from '../../../public/upgrade/feature/insurance/insurance-edit.component';
import * as import149 from '../../../public/upgrade/feature/pointOfSale/edit/point-of-sale-edit.component';
import * as import150 from '../../../public/upgrade/feature/additionalPoint/edit/additional-point-edit.component';
import * as import151 from '../../../public/upgrade/feature/ageRange/age-range.component';
import * as import152 from '../../../public/upgrade/feature/carTemplate/moderate/car-template-moderate.component';
import * as import153 from '../../../public/upgrade/feature/carTemplate/list/car-template-list.component';
import * as import154 from '../../../public/upgrade/feature/carTemplate/edit/car-template-edit.component';
import * as import155 from 'ngx-cookie/src/cookie.factory';
import * as import156 from '@angular/router/src/route_reuse_strategy';
import * as import157 from '@angular/router/src/router';
import * as import158 from '@angular/common/src/location/platform_location';
import * as import159 from '@angular/core/src/console';
import * as import160 from '@angular/common/src/location/location_strategy';
import * as import161 from '@angular/core/src/error_handler';
import * as import162 from '@angular/platform-browser/src/dom/dom_tokens';
import * as import163 from '@angular/platform-browser/src/dom/animation_driver';
import * as import164 from '@angular/core/src/render/api';
import * as import165 from '@angular/core/src/security';
import * as import166 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import167 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import168 from '@angular/http/src/interfaces';
import * as import169 from '@angular/http/src/http';
import * as import170 from '@angular/router/src/router_config_loader';
import * as import171 from '@ngx-translate/core/src/translate.loader';
import * as import172 from 'ngx-cookie/src/cookie.service';
import * as import173 from '../../../public/upgrade/core/logger.service';
import * as import174 from '@angular/core/src/linker/ng_module_factory_loader';
import * as import175 from '@angular/router/src/url_handling_strategy';
import * as import176 from '@angular/router/src/router_state';
class SaraV2AppModuleInjector extends import0.NgModuleInjector<import1.SaraV2AppModule> {
  _CommonModule_0:import2.CommonModule;
  _ApplicationModule_1:import3.ApplicationModule;
  _BrowserModule_2:import4.BrowserModule;
  _UpgradeModule_3:import5.UpgradeModule;
  _InternalFormsSharedModule_4:import6.InternalFormsSharedModule;
  _FormsModule_5:import7.FormsModule;
  _HttpModule_6:import8.HttpModule;
  _ROUTER_FORROOT_GUARD_7:any;
  _RouterModule_8:import9.RouterModule;
  _AuditRoutingModule_9:import10.AuditRoutingModule;
  _DatePickerModule_10:import11.DatePickerModule;
  _TranslateModule_11:import12.TranslateModule;
  _AuditModule_12:import13.AuditModule;
  _ReactiveFormsModule_13:import7.ReactiveFormsModule;
  _PickupPointFeeRoutingModule_14:import14.PickupPointFeeRoutingModule;
  _SharedModule_15:import15.SharedModule;
  _PickupPointFeeModule_16:import16.PickupPointFeeModule;
  _CoreModule_17:import17.CoreModule;
  _ContactRoutingModule_18:import18.ContactRoutingModule;
  _ContactModule_19:import19.ContactModule;
  _SampleRoutingModule_20:import20.SampleRoutingModule;
  _Sample2Module_21:import21.Sample2Module;
  _InternalErrorRoutingModule_22:import22.InternalErrorRoutingModule;
  _InternalErrorModule_23:import23.InternalErrorModule;
  _HomeRoutingModule_24:import24.HomeRoutingModule;
  _HomeModule_25:import25.HomeModule;
  _RestrictionsRoutingModule_26:import26.RestrictionsRoutingModule;
  _RestrictionsModule_27:import27.RestrictionsModule;
  _BookingRoutingModule_28:import28.BookingRoutingModule;
  _BookingModule_29:import29.BookingModule;
  _LogoutRoutingModule_30:import30.LogoutRoutingModule;
  _LogoutModule_31:import31.LogoutModule;
  _AdditionalRoutingModule_32:import32.AdditionalRoutingModule;
  _AdditionalModule_33:import33.AdditionalModule;
  _InsuranceRoutingModule_34:import34.InsuranceRoutingModule;
  _InsuranceModule_35:import35.InsuranceModule;
  _PointOfSaleRoutingModule_36:import36.PointOfSaleRoutingModule;
  _TextMaskModule_37:import37.TextMaskModule;
  _PointOfSaleModule_38:import38.PointOfSaleModule;
  _AdditionalPointRoutingModule_39:import39.AdditionalPointRoutingModule;
  _AdditionalPointModule_40:import40.AdditionalPointModule;
  _AgeRangeRoutingModule_41:import41.AgeRangeRoutingModule;
  _AgeRangeModule_42:import42.AgeRangeModule;
  _CarTemplateRoutingModule_43:import43.CarTemplateRoutingModule;
  _CarTemplateModule_44:import44.CarTemplateModule;
  _FeatureModule_45:import45.FeatureModule;
  _CookieModule_46:import46.CookieModule;
  _SaraV2AppModule_47:import1.SaraV2AppModule;
  __LOCALE_ID_48:any;
  __NgLocalization_49:import47.NgLocaleLocalization;
  _WindowRef_50:import48.WindowRef;
  _NewRelicService_51:import49.NewRelicService;
  _APP_BASE_HREF_52:any;
  _LocationStrategy_53:import50.CustomLocationStrategy;
  _Location_54:import51.Location;
  _ErrorLogService_55:import52.ErrorLogService;
  _NotificationService_56:import53.NotificationService;
  _LoadingWheelService_57:import54.LoadingWheelService;
  _ErrorHandler_58:import55.AngularErrorHandler;
  _ApplicationInitStatus_59:import56.ApplicationInitStatus;
  _Testability_60:import57.Testability;
  _ApplicationRef__61:import58.ApplicationRef_;
  __ApplicationRef_62:any;
  __Compiler_63:import59.Compiler;
  __APP_ID_64:any;
  __DOCUMENT_65:any;
  __HAMMER_GESTURE_CONFIG_66:import60.HammerGestureConfig;
  __EVENT_MANAGER_PLUGINS_67:any[];
  __EventManager_68:import61.EventManager;
  __DomSharedStylesHost_69:import62.DomSharedStylesHost;
  __AnimationDriver_70:any;
  __DomRootRenderer_71:import63.DomRootRenderer_;
  __NgProbeToken_72:any[];
  __RootRenderer_73:any;
  __DomSanitizer_74:import64.DomSanitizerImpl;
  __Sanitizer_75:any;
  __AnimationQueue_76:import65.AnimationQueue;
  __ViewUtils_77:import66.ViewUtils;
  __IterableDiffers_78:any;
  __KeyValueDiffers_79:any;
  __SharedStylesHost_80:any;
  __Title_81:import67.Title;
  ___injector_82:any;
  ___rootScope_83:any;
  ___compile_84:any;
  ___parse_85:any;
  __RadioControlRegistry_86:import68.RadioControlRegistry;
  __BrowserXhr_87:import69.BrowserXhr;
  __ResponseOptions_88:import70.BaseResponseOptions;
  __XSRFStrategy_89:any;
  __XHRBackend_90:import71.XHRBackend;
  __RequestOptions_91:import72.BaseRequestOptions;
  __Http_92:any;
  __ROUTES_93:any[];
  __CalendarConfig_94:import73.CalendarConfig;
  __FormBuilder_95:import74.FormBuilder;
  __AuthenticateUserService_96:import75.AuthenticateUserService;
  __TranslateStore_97:import76.TranslateStore;
  __TranslateLoader_98:any;
  __TranslateCompiler_99:import77.TranslateFakeCompiler;
  __TranslateParser_100:import78.TranslateDefaultParser;
  __MissingTranslationHandler_101:import79.FakeMissingTranslationHandler;
  __USE_DEFAULT_LANG_102:any;
  __USE_STORE_103:any;
  __TranslateService_104:import80.TranslateService;
  __ModalService_105:import81.ModalService;
  __CompanyServiceA2_106:import82.CompanyServiceA2;
  __COOKIE_OPTIONS_107:any;
  __CookieOptionsProvider_108:import83.CookieOptionsProvider;
  __CookieService_109:any;
  __GAService_110:import84.GAService;
  __SessionService_111:import85.SessionService;
  __SidebarService_112:import86.SidebarService;
  __InformationModalService_113:import87.InformationModalService;
  __LogoutService_114:import88.LogoutService;
  __BackgroundColorService_115:import89.BackgroundColorService;
  __ValidatorService_116:import90.ValidatorService;
  __FormModalService_117:import91.FormModalService;
  __ContractService_118:import92.ContractService;
  __GeoServiceA2_119:import93.GeoServiceA2;
  __VersionCheckService_120:import94.VersionCheckService;
  __AlfredA2Service_121:import95.AlfredA2Service;
  __GeoCodeService_122:import96.GeoCodeService;
  __NavigationService_123:import97.NavigationService;
  __EmailValidatorService_124:import98.EmailValidatorService;
  __LegalDocumentService_125:import99.LegalDocumentService;
  __ContractStatesService_126:import100.ContractStatesService;
  __LoggerService_127:import101.ConsoleLoggerService;
  __HomeService_128:import102.HomeService;
  __PointOfSaleServiceA2_129:import103.PointOfSaleServiceA2;
  __UrlSerializer_130:import104.DefaultUrlSerializer;
  __RouterOutletMap_131:import105.RouterOutletMap;
  __NgModuleFactoryLoader_132:import106.SystemJsNgModuleLoader;
  __ROUTER_CONFIGURATION_133:any;
  __UrlHandlingStrategy_134:import50.Ng1Ng2UrlHandlingStrategy;
  __Router_135:any;
  __ActivatedRoute_136:any;
  _NoPreloading_137:import107.NoPreloading;
  _PreloadingStrategy_138:any;
  _RouterPreloader_139:import107.RouterPreloader;
  __PreloadAllModules_140:import107.PreloadAllModules;
  __ROUTER_INITIALIZER_141:any;
  __APP_BOOTSTRAP_LISTENER_142:any[];
  constructor(parent:import108.Injector) {
    super(parent,[
      import109.AuditComponentNgFactory,
      import110.PickupPointFeeListComponentNgFactory,
      import111.PickupPointFeeEditComponentNgFactory,
      import112.ContactComponentNgFactory,
      import113.SampleComponentNgFactory,
      import114.InternalErrorComponentNgFactory,
      import115.HomeComponentNgFactory,
      import116.RestrictionsComponentNgFactory,
      import117.BookingComponentNgFactory,
      import118.BookingDetailComponentNgFactory,
      import119.LogoutComponentNgFactory,
      import120.AdditionalEditComponentNgFactory,
      import121.InsuranceEditComponentNgFactory,
      import122.PointOfSaleEditComponentNgFactory,
      import123.AdditionalPointEditComponentNgFactory,
      import124.AgeRangeComponentNgFactory,
      import125.CarTemplateModerateComponentNgFactory,
      import126.CarTemplateListComponentNgFactory,
      import127.CarTemplateEditComponentNgFactory,
      import128.RootCmpNgFactory
    ]
    ,[import128.RootCmpNgFactory]);
  }
  get _LOCALE_ID_48():any {
    if ((this.__LOCALE_ID_48 == null)) { (this.__LOCALE_ID_48 = import3._localeFactory(this.parent.get(import129.LOCALE_ID,(null as any)))); }
    return this.__LOCALE_ID_48;
  }
  get _NgLocalization_49():import47.NgLocaleLocalization {
    if ((this.__NgLocalization_49 == null)) { (this.__NgLocalization_49 = new import47.NgLocaleLocalization(this._LOCALE_ID_48)); }
    return this.__NgLocalization_49;
  }
  get _ApplicationRef_62():any {
    if ((this.__ApplicationRef_62 == null)) { (this.__ApplicationRef_62 = this._ApplicationRef__61); }
    return this.__ApplicationRef_62;
  }
  get _Compiler_63():import59.Compiler {
    if ((this.__Compiler_63 == null)) { (this.__Compiler_63 = new import59.Compiler()); }
    return this.__Compiler_63;
  }
  get _APP_ID_64():any {
    if ((this.__APP_ID_64 == null)) { (this.__APP_ID_64 = import130._appIdRandomProviderFactory()); }
    return this.__APP_ID_64;
  }
  get _DOCUMENT_65():any {
    if ((this.__DOCUMENT_65 == null)) { (this.__DOCUMENT_65 = import4._document()); }
    return this.__DOCUMENT_65;
  }
  get _HAMMER_GESTURE_CONFIG_66():import60.HammerGestureConfig {
    if ((this.__HAMMER_GESTURE_CONFIG_66 == null)) { (this.__HAMMER_GESTURE_CONFIG_66 = new import60.HammerGestureConfig()); }
    return this.__HAMMER_GESTURE_CONFIG_66;
  }
  get _EVENT_MANAGER_PLUGINS_67():any[] {
    if ((this.__EVENT_MANAGER_PLUGINS_67 == null)) { (this.__EVENT_MANAGER_PLUGINS_67 = [
      new import131.DomEventsPlugin(),
      new import132.KeyEventsPlugin(),
      new import60.HammerGesturesPlugin(this._HAMMER_GESTURE_CONFIG_66)
    ]
    ); }
    return this.__EVENT_MANAGER_PLUGINS_67;
  }
  get _EventManager_68():import61.EventManager {
    if ((this.__EventManager_68 == null)) { (this.__EventManager_68 = new import61.EventManager(this._EVENT_MANAGER_PLUGINS_67,this.parent.get(import133.NgZone))); }
    return this.__EventManager_68;
  }
  get _DomSharedStylesHost_69():import62.DomSharedStylesHost {
    if ((this.__DomSharedStylesHost_69 == null)) { (this.__DomSharedStylesHost_69 = new import62.DomSharedStylesHost(this._DOCUMENT_65)); }
    return this.__DomSharedStylesHost_69;
  }
  get _AnimationDriver_70():any {
    if ((this.__AnimationDriver_70 == null)) { (this.__AnimationDriver_70 = import4._resolveDefaultAnimationDriver()); }
    return this.__AnimationDriver_70;
  }
  get _DomRootRenderer_71():import63.DomRootRenderer_ {
    if ((this.__DomRootRenderer_71 == null)) { (this.__DomRootRenderer_71 = new import63.DomRootRenderer_(this._DOCUMENT_65,this._EventManager_68,this._DomSharedStylesHost_69,this._AnimationDriver_70,this._APP_ID_64)); }
    return this.__DomRootRenderer_71;
  }
  get _NgProbeToken_72():any[] {
    if ((this.__NgProbeToken_72 == null)) { (this.__NgProbeToken_72 = [import9.routerNgProbeToken()]); }
    return this.__NgProbeToken_72;
  }
  get _RootRenderer_73():any {
    if ((this.__RootRenderer_73 == null)) { (this.__RootRenderer_73 = import134._createConditionalRootRenderer(this._DomRootRenderer_71,this.parent.get(import134.NgProbeToken,(null as any)),this._NgProbeToken_72)); }
    return this.__RootRenderer_73;
  }
  get _DomSanitizer_74():import64.DomSanitizerImpl {
    if ((this.__DomSanitizer_74 == null)) { (this.__DomSanitizer_74 = new import64.DomSanitizerImpl()); }
    return this.__DomSanitizer_74;
  }
  get _Sanitizer_75():any {
    if ((this.__Sanitizer_75 == null)) { (this.__Sanitizer_75 = this._DomSanitizer_74); }
    return this.__Sanitizer_75;
  }
  get _AnimationQueue_76():import65.AnimationQueue {
    if ((this.__AnimationQueue_76 == null)) { (this.__AnimationQueue_76 = new import65.AnimationQueue(this.parent.get(import133.NgZone))); }
    return this.__AnimationQueue_76;
  }
  get _ViewUtils_77():import66.ViewUtils {
    if ((this.__ViewUtils_77 == null)) { (this.__ViewUtils_77 = new import66.ViewUtils(this._RootRenderer_73,this._Sanitizer_75,this._AnimationQueue_76)); }
    return this.__ViewUtils_77;
  }
  get _IterableDiffers_78():any {
    if ((this.__IterableDiffers_78 == null)) { (this.__IterableDiffers_78 = import3._iterableDiffersFactory()); }
    return this.__IterableDiffers_78;
  }
  get _KeyValueDiffers_79():any {
    if ((this.__KeyValueDiffers_79 == null)) { (this.__KeyValueDiffers_79 = import3._keyValueDiffersFactory()); }
    return this.__KeyValueDiffers_79;
  }
  get _SharedStylesHost_80():any {
    if ((this.__SharedStylesHost_80 == null)) { (this.__SharedStylesHost_80 = this._DomSharedStylesHost_69); }
    return this.__SharedStylesHost_80;
  }
  get _Title_81():import67.Title {
    if ((this.__Title_81 == null)) { (this.__Title_81 = new import67.Title()); }
    return this.__Title_81;
  }
  get __injector_82():any {
    if ((this.___injector_82 == null)) { (this.___injector_82 = import135.injectorFactory()); }
    return this.___injector_82;
  }
  get __rootScope_83():any {
    if ((this.___rootScope_83 == null)) { (this.___rootScope_83 = import135.rootScopeFactory(this.__injector_82)); }
    return this.___rootScope_83;
  }
  get __compile_84():any {
    if ((this.___compile_84 == null)) { (this.___compile_84 = import135.compileFactory(this.__injector_82)); }
    return this.___compile_84;
  }
  get __parse_85():any {
    if ((this.___parse_85 == null)) { (this.___parse_85 = import135.parseFactory(this.__injector_82)); }
    return this.___parse_85;
  }
  get _RadioControlRegistry_86():import68.RadioControlRegistry {
    if ((this.__RadioControlRegistry_86 == null)) { (this.__RadioControlRegistry_86 = new import68.RadioControlRegistry()); }
    return this.__RadioControlRegistry_86;
  }
  get _BrowserXhr_87():import69.BrowserXhr {
    if ((this.__BrowserXhr_87 == null)) { (this.__BrowserXhr_87 = new import69.BrowserXhr()); }
    return this.__BrowserXhr_87;
  }
  get _ResponseOptions_88():import70.BaseResponseOptions {
    if ((this.__ResponseOptions_88 == null)) { (this.__ResponseOptions_88 = new import70.BaseResponseOptions()); }
    return this.__ResponseOptions_88;
  }
  get _XSRFStrategy_89():any {
    if ((this.__XSRFStrategy_89 == null)) { (this.__XSRFStrategy_89 = import8._createDefaultCookieXSRFStrategy()); }
    return this.__XSRFStrategy_89;
  }
  get _XHRBackend_90():import71.XHRBackend {
    if ((this.__XHRBackend_90 == null)) { (this.__XHRBackend_90 = new import71.XHRBackend(this._BrowserXhr_87,this._ResponseOptions_88,this._XSRFStrategy_89)); }
    return this.__XHRBackend_90;
  }
  get _RequestOptions_91():import72.BaseRequestOptions {
    if ((this.__RequestOptions_91 == null)) { (this.__RequestOptions_91 = new import72.BaseRequestOptions()); }
    return this.__RequestOptions_91;
  }
  get _Http_92():any {
    if ((this.__Http_92 == null)) { (this.__Http_92 = import8.httpFactory(this._XHRBackend_90,this._RequestOptions_91)); }
    return this.__Http_92;
  }
  get _ROUTES_93():any[] {
    if ((this.__ROUTES_93 == null)) { (this.__ROUTES_93 = [
      [
        {
          path: 'audit-a2',
          component: import136.AuditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/audit-a2',
          component: import136.AuditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/pickupPointFee',
          component: import137.PickupPointFeeListComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/pickupPointFee',
          component: import137.PickupPointFeeListComponent
        }
        ,
        {
          path: 'company/:companyId/pickupPointFee/:id',
          component: import138.PickupPointFeeEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/pickupPointFee/:id',
          component: import138.PickupPointFeeEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/contact',
          component: import139.ContactComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/contact',
          component: import139.ContactComponent
        }

      ]
      ,
      [
        {
          path: 'sample-v2',
          component: import140.SampleComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/sample-v2',
          component: import140.SampleComponent
        }

      ]
      ,
      [
        {
          path: 'internal-error',
          component: import141.InternalErrorComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/internal-error',
          component: import141.InternalErrorComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/home',
          component: import142.HomeComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/home',
          component: import142.HomeComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/restrictions',
          component: import143.RestrictionsComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/restrictions',
          component: import143.RestrictionsComponent
        }

      ]
      ,
      [
        {
          path: 'booking',
          component: import144.BookingComponent
        }
        ,
        {
          path: 'booking/:id',
          component: import145.BookingDetailComponent
        }
        ,
        {
          path: 'company/:companyId/booking',
          component: import144.BookingComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/booking',
          component: import144.BookingComponent
        }
        ,
        {
          path: 'company/:companyId/booking/:id',
          component: import145.BookingDetailComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/booking/:id',
          component: import145.BookingDetailComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/booking',
          component: import144.BookingComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/booking/:id',
          component: import145.BookingDetailComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/home',
          component: import142.HomeComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/home',
          component: import142.HomeComponent
        }

      ]
      ,
      [
        {
          path: 'logout',
          component: import146.LogoutComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/logout',
          component: import146.LogoutComponent
        }

      ]
      ,
      [
        {
          path: 'company/:companyId/additionals/add',
          component: import147.AdditionalEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/additionals/add',
          component: import147.AdditionalEditComponent
        }
        ,
        {
          path: 'company/:companyId/additionals/:id',
          component: import147.AdditionalEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/additionals/:id',
          component: import147.AdditionalEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:companyId/insurances/add',
          component: import148.InsuranceEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/insurances/add',
          component: import148.InsuranceEditComponent
        }
        ,
        {
          path: 'company/:companyId/insurances/:id',
          component: import148.InsuranceEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/insurances/:id',
          component: import148.InsuranceEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:companyId/pointsOfSale/:id',
          component: import149.PointOfSaleEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/pointsOfSale/:id',
          component: import149.PointOfSaleEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:companyId/additionalPoint/:id',
          component: import150.AdditionalPointEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/additionalPoint/:id',
          component: import150.AdditionalPointEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:companyId/pointsOfSale/:id',
          component: import149.PointOfSaleEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/pointsOfSale/:id',
          component: import149.PointOfSaleEditComponent
        }

      ]
      ,
      [
        {
          path: 'company/:id/agerange',
          component: import151.AgeRangeComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:id/agerange',
          component: import151.AgeRangeComponent
        }

      ]
      ,
      [
        {
          path: 'moderateCarTemplate',
          component: import152.CarTemplateModerateComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/moderateCarTemplate',
          component: import152.CarTemplateModerateComponent
        }
        ,
        {
          path: 'company/:companyId/carTemplate',
          component: import153.CarTemplateListComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/carTemplate',
          component: import153.CarTemplateListComponent,
          pathMatch: 'full'
        }
        ,
        {
          path: 'company/:companyId/carTemplate/picture/:status',
          component: import153.CarTemplateListComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/carTemplate/picture/:status',
          component: import153.CarTemplateListComponent
        }
        ,
        {
          path: 'company/:companyId/carTemplate/add',
          component: import154.CarTemplateEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/carTemplate/add',
          component: import154.CarTemplateEditComponent
        }
        ,
        {
          path: 'company/:companyId/carTemplate/:id',
          component: import154.CarTemplateEditComponent
        }
        ,
        {
          path: 'cars-sara-v2/web/company/:companyId/carTemplate/:id',
          component: import154.CarTemplateEditComponent
        }

      ]
      ,
      ([] as any[])
    ]
    ); }
    return this.__ROUTES_93;
  }
  get _CalendarConfig_94():import73.CalendarConfig {
    if ((this.__CalendarConfig_94 == null)) { (this.__CalendarConfig_94 = new import73.CalendarConfig()); }
    return this.__CalendarConfig_94;
  }
  get _FormBuilder_95():import74.FormBuilder {
    if ((this.__FormBuilder_95 == null)) { (this.__FormBuilder_95 = new import74.FormBuilder()); }
    return this.__FormBuilder_95;
  }
  get _AuthenticateUserService_96():import75.AuthenticateUserService {
    if ((this.__AuthenticateUserService_96 == null)) { (this.__AuthenticateUserService_96 = new import75.AuthenticateUserService(this._Http_92)); }
    return this.__AuthenticateUserService_96;
  }
  get _TranslateStore_97():import76.TranslateStore {
    if ((this.__TranslateStore_97 == null)) { (this.__TranslateStore_97 = new import76.TranslateStore()); }
    return this.__TranslateStore_97;
  }
  get _TranslateLoader_98():any {
    if ((this.__TranslateLoader_98 == null)) { (this.__TranslateLoader_98 = import1.HttpLoaderFactory(this._Http_92)); }
    return this.__TranslateLoader_98;
  }
  get _TranslateCompiler_99():import77.TranslateFakeCompiler {
    if ((this.__TranslateCompiler_99 == null)) { (this.__TranslateCompiler_99 = new import77.TranslateFakeCompiler()); }
    return this.__TranslateCompiler_99;
  }
  get _TranslateParser_100():import78.TranslateDefaultParser {
    if ((this.__TranslateParser_100 == null)) { (this.__TranslateParser_100 = new import78.TranslateDefaultParser()); }
    return this.__TranslateParser_100;
  }
  get _MissingTranslationHandler_101():import79.FakeMissingTranslationHandler {
    if ((this.__MissingTranslationHandler_101 == null)) { (this.__MissingTranslationHandler_101 = new import79.FakeMissingTranslationHandler()); }
    return this.__MissingTranslationHandler_101;
  }
  get _USE_DEFAULT_LANG_102():any {
    if ((this.__USE_DEFAULT_LANG_102 == null)) { (this.__USE_DEFAULT_LANG_102 = (undefined as any)); }
    return this.__USE_DEFAULT_LANG_102;
  }
  get _USE_STORE_103():any {
    if ((this.__USE_STORE_103 == null)) { (this.__USE_STORE_103 = (undefined as any)); }
    return this.__USE_STORE_103;
  }
  get _TranslateService_104():import80.TranslateService {
    if ((this.__TranslateService_104 == null)) { (this.__TranslateService_104 = new import80.TranslateService(this._TranslateStore_97,this._TranslateLoader_98,this._TranslateCompiler_99,this._TranslateParser_100,this._MissingTranslationHandler_101,this._USE_DEFAULT_LANG_102,this._USE_STORE_103)); }
    return this.__TranslateService_104;
  }
  get _ModalService_105():import81.ModalService {
    if ((this.__ModalService_105 == null)) { (this.__ModalService_105 = new import81.ModalService(this._TranslateService_104)); }
    return this.__ModalService_105;
  }
  get _CompanyServiceA2_106():import82.CompanyServiceA2 {
    if ((this.__CompanyServiceA2_106 == null)) { (this.__CompanyServiceA2_106 = new import82.CompanyServiceA2(this._Http_92)); }
    return this.__CompanyServiceA2_106;
  }
  get _COOKIE_OPTIONS_107():any {
    if ((this.__COOKIE_OPTIONS_107 == null)) { (this.__COOKIE_OPTIONS_107 = {}); }
    return this.__COOKIE_OPTIONS_107;
  }
  get _CookieOptionsProvider_108():import83.CookieOptionsProvider {
    if ((this.__CookieOptionsProvider_108 == null)) { (this.__CookieOptionsProvider_108 = new import83.CookieOptionsProvider(this._COOKIE_OPTIONS_107,this)); }
    return this.__CookieOptionsProvider_108;
  }
  get _CookieService_109():any {
    if ((this.__CookieService_109 == null)) { (this.__CookieService_109 = import155.cookieServiceFactory(this._CookieOptionsProvider_108)); }
    return this.__CookieService_109;
  }
  get _GAService_110():import84.GAService {
    if ((this.__GAService_110 == null)) { (this.__GAService_110 = new import84.GAService()); }
    return this.__GAService_110;
  }
  get _SessionService_111():import85.SessionService {
    if ((this.__SessionService_111 == null)) { (this.__SessionService_111 = new import85.SessionService(this._CompanyServiceA2_106,this._CookieService_109,this._GAService_110,this._NewRelicService_51)); }
    return this.__SessionService_111;
  }
  get _SidebarService_112():import86.SidebarService {
    if ((this.__SidebarService_112 == null)) { (this.__SidebarService_112 = new import86.SidebarService(this._SessionService_111)); }
    return this.__SidebarService_112;
  }
  get _InformationModalService_113():import87.InformationModalService {
    if ((this.__InformationModalService_113 == null)) { (this.__InformationModalService_113 = new import87.InformationModalService()); }
    return this.__InformationModalService_113;
  }
  get _LogoutService_114():import88.LogoutService {
    if ((this.__LogoutService_114 == null)) { (this.__LogoutService_114 = new import88.LogoutService(this._Http_92)); }
    return this.__LogoutService_114;
  }
  get _BackgroundColorService_115():import89.BackgroundColorService {
    if ((this.__BackgroundColorService_115 == null)) { (this.__BackgroundColorService_115 = new import89.BackgroundColorService()); }
    return this.__BackgroundColorService_115;
  }
  get _ValidatorService_116():import90.ValidatorService {
    if ((this.__ValidatorService_116 == null)) { (this.__ValidatorService_116 = new import90.ValidatorService()); }
    return this.__ValidatorService_116;
  }
  get _FormModalService_117():import91.FormModalService {
    if ((this.__FormModalService_117 == null)) { (this.__FormModalService_117 = new import91.FormModalService()); }
    return this.__FormModalService_117;
  }
  get _ContractService_118():import92.ContractService {
    if ((this.__ContractService_118 == null)) { (this.__ContractService_118 = new import92.ContractService(this._Http_92)); }
    return this.__ContractService_118;
  }
  get _GeoServiceA2_119():import93.GeoServiceA2 {
    if ((this.__GeoServiceA2_119 == null)) { (this.__GeoServiceA2_119 = new import93.GeoServiceA2(this._Http_92)); }
    return this.__GeoServiceA2_119;
  }
  get _VersionCheckService_120():import94.VersionCheckService {
    if ((this.__VersionCheckService_120 == null)) { (this.__VersionCheckService_120 = new import94.VersionCheckService(this._Http_92,this._WindowRef_50)); }
    return this.__VersionCheckService_120;
  }
  get _AlfredA2Service_121():import95.AlfredA2Service {
    if ((this.__AlfredA2Service_121 == null)) { (this.__AlfredA2Service_121 = new import95.AlfredA2Service(this._Http_92)); }
    return this.__AlfredA2Service_121;
  }
  get _GeoCodeService_122():import96.GeoCodeService {
    if ((this.__GeoCodeService_122 == null)) { (this.__GeoCodeService_122 = new import96.GeoCodeService()); }
    return this.__GeoCodeService_122;
  }
  get _NavigationService_123():import97.NavigationService {
    if ((this.__NavigationService_123 == null)) { (this.__NavigationService_123 = new import97.NavigationService(this._SidebarService_112)); }
    return this.__NavigationService_123;
  }
  get _EmailValidatorService_124():import98.EmailValidatorService {
    if ((this.__EmailValidatorService_124 == null)) { (this.__EmailValidatorService_124 = new import98.EmailValidatorService()); }
    return this.__EmailValidatorService_124;
  }
  get _LegalDocumentService_125():import99.LegalDocumentService {
    if ((this.__LegalDocumentService_125 == null)) { (this.__LegalDocumentService_125 = new import99.LegalDocumentService(this._Http_92)); }
    return this.__LegalDocumentService_125;
  }
  get _ContractStatesService_126():import100.ContractStatesService {
    if ((this.__ContractStatesService_126 == null)) { (this.__ContractStatesService_126 = new import100.ContractStatesService(this._NotificationService_56)); }
    return this.__ContractStatesService_126;
  }
  get _LoggerService_127():import101.ConsoleLoggerService {
    if ((this.__LoggerService_127 == null)) { (this.__LoggerService_127 = new import101.ConsoleLoggerService()); }
    return this.__LoggerService_127;
  }
  get _HomeService_128():import102.HomeService {
    if ((this.__HomeService_128 == null)) { (this.__HomeService_128 = new import102.HomeService(this._Http_92,this._CompanyServiceA2_106)); }
    return this.__HomeService_128;
  }
  get _PointOfSaleServiceA2_129():import103.PointOfSaleServiceA2 {
    if ((this.__PointOfSaleServiceA2_129 == null)) { (this.__PointOfSaleServiceA2_129 = new import103.PointOfSaleServiceA2(this._Http_92,this._AlfredA2Service_121)); }
    return this.__PointOfSaleServiceA2_129;
  }
  get _UrlSerializer_130():import104.DefaultUrlSerializer {
    if ((this.__UrlSerializer_130 == null)) { (this.__UrlSerializer_130 = new import104.DefaultUrlSerializer()); }
    return this.__UrlSerializer_130;
  }
  get _RouterOutletMap_131():import105.RouterOutletMap {
    if ((this.__RouterOutletMap_131 == null)) { (this.__RouterOutletMap_131 = new import105.RouterOutletMap()); }
    return this.__RouterOutletMap_131;
  }
  get _NgModuleFactoryLoader_132():import106.SystemJsNgModuleLoader {
    if ((this.__NgModuleFactoryLoader_132 == null)) { (this.__NgModuleFactoryLoader_132 = new import106.SystemJsNgModuleLoader(this._Compiler_63,this.parent.get(import106.SystemJsNgModuleLoaderConfig,(null as any)))); }
    return this.__NgModuleFactoryLoader_132;
  }
  get _ROUTER_CONFIGURATION_133():any {
    if ((this.__ROUTER_CONFIGURATION_133 == null)) { (this.__ROUTER_CONFIGURATION_133 = {}); }
    return this.__ROUTER_CONFIGURATION_133;
  }
  get _UrlHandlingStrategy_134():import50.Ng1Ng2UrlHandlingStrategy {
    if ((this.__UrlHandlingStrategy_134 == null)) { (this.__UrlHandlingStrategy_134 = new import50.Ng1Ng2UrlHandlingStrategy()); }
    return this.__UrlHandlingStrategy_134;
  }
  get _Router_135():any {
    if ((this.__Router_135 == null)) { (this.__Router_135 = import9.setupRouter(this._ApplicationRef_62,this._UrlSerializer_130,this._RouterOutletMap_131,this._Location_54,this,this._NgModuleFactoryLoader_132,this._Compiler_63,this._ROUTES_93,this._ROUTER_CONFIGURATION_133,this._UrlHandlingStrategy_134,this.parent.get(import156.RouteReuseStrategy,(null as any)))); }
    return this.__Router_135;
  }
  get _ActivatedRoute_136():any {
    if ((this.__ActivatedRoute_136 == null)) { (this.__ActivatedRoute_136 = import9.rootRoute(this._Router_135)); }
    return this.__ActivatedRoute_136;
  }
  get _PreloadAllModules_140():import107.PreloadAllModules {
    if ((this.__PreloadAllModules_140 == null)) { (this.__PreloadAllModules_140 = new import107.PreloadAllModules()); }
    return this.__PreloadAllModules_140;
  }
  get _ROUTER_INITIALIZER_141():any {
    if ((this.__ROUTER_INITIALIZER_141 == null)) { (this.__ROUTER_INITIALIZER_141 = import9.initialRouterNavigation(this._Router_135,this._ApplicationRef_62,this._RouterPreloader_139,this._ROUTER_CONFIGURATION_133)); }
    return this.__ROUTER_INITIALIZER_141;
  }
  get _APP_BOOTSTRAP_LISTENER_142():any[] {
    if ((this.__APP_BOOTSTRAP_LISTENER_142 == null)) { (this.__APP_BOOTSTRAP_LISTENER_142 = [this._ROUTER_INITIALIZER_141]); }
    return this.__APP_BOOTSTRAP_LISTENER_142;
  }
  createInternal():import1.SaraV2AppModule {
    this._CommonModule_0 = new import2.CommonModule();
    this._ApplicationModule_1 = new import3.ApplicationModule();
    this._BrowserModule_2 = new import4.BrowserModule(this.parent.get(import4.BrowserModule,(null as any)));
    this._UpgradeModule_3 = new import5.UpgradeModule(this,this.parent.get(import133.NgZone));
    this._InternalFormsSharedModule_4 = new import6.InternalFormsSharedModule();
    this._FormsModule_5 = new import7.FormsModule();
    this._HttpModule_6 = new import8.HttpModule();
    this._ROUTER_FORROOT_GUARD_7 = import9.provideForRootGuard(this.parent.get(import157.Router,(null as any)));
    this._RouterModule_8 = new import9.RouterModule(this._ROUTER_FORROOT_GUARD_7);
    this._AuditRoutingModule_9 = new import10.AuditRoutingModule();
    this._DatePickerModule_10 = new import11.DatePickerModule();
    this._TranslateModule_11 = new import12.TranslateModule();
    this._AuditModule_12 = new import13.AuditModule();
    this._ReactiveFormsModule_13 = new import7.ReactiveFormsModule();
    this._PickupPointFeeRoutingModule_14 = new import14.PickupPointFeeRoutingModule();
    this._SharedModule_15 = new import15.SharedModule();
    this._PickupPointFeeModule_16 = new import16.PickupPointFeeModule();
    this._CoreModule_17 = new import17.CoreModule();
    this._ContactRoutingModule_18 = new import18.ContactRoutingModule();
    this._ContactModule_19 = new import19.ContactModule();
    this._SampleRoutingModule_20 = new import20.SampleRoutingModule();
    this._Sample2Module_21 = new import21.Sample2Module();
    this._InternalErrorRoutingModule_22 = new import22.InternalErrorRoutingModule();
    this._InternalErrorModule_23 = new import23.InternalErrorModule();
    this._HomeRoutingModule_24 = new import24.HomeRoutingModule();
    this._HomeModule_25 = new import25.HomeModule();
    this._RestrictionsRoutingModule_26 = new import26.RestrictionsRoutingModule();
    this._RestrictionsModule_27 = new import27.RestrictionsModule();
    this._BookingRoutingModule_28 = new import28.BookingRoutingModule();
    this._BookingModule_29 = new import29.BookingModule();
    this._LogoutRoutingModule_30 = new import30.LogoutRoutingModule();
    this._LogoutModule_31 = new import31.LogoutModule();
    this._AdditionalRoutingModule_32 = new import32.AdditionalRoutingModule();
    this._AdditionalModule_33 = new import33.AdditionalModule();
    this._InsuranceRoutingModule_34 = new import34.InsuranceRoutingModule();
    this._InsuranceModule_35 = new import35.InsuranceModule();
    this._PointOfSaleRoutingModule_36 = new import36.PointOfSaleRoutingModule();
    this._TextMaskModule_37 = new import37.TextMaskModule();
    this._PointOfSaleModule_38 = new import38.PointOfSaleModule();
    this._AdditionalPointRoutingModule_39 = new import39.AdditionalPointRoutingModule();
    this._AdditionalPointModule_40 = new import40.AdditionalPointModule();
    this._AgeRangeRoutingModule_41 = new import41.AgeRangeRoutingModule();
    this._AgeRangeModule_42 = new import42.AgeRangeModule();
    this._CarTemplateRoutingModule_43 = new import43.CarTemplateRoutingModule();
    this._CarTemplateModule_44 = new import44.CarTemplateModule();
    this._FeatureModule_45 = new import45.FeatureModule();
    this._CookieModule_46 = new import46.CookieModule();
    this._SaraV2AppModule_47 = new import1.SaraV2AppModule(this._UpgradeModule_3);
    this._WindowRef_50 = new import48.WindowRef();
    this._NewRelicService_51 = new import49.NewRelicService(this._WindowRef_50);
    this._APP_BASE_HREF_52 = '/cars-sara-v2/web/';
    this._LocationStrategy_53 = new import50.CustomLocationStrategy(this.parent.get(import158.PlatformLocation),this._APP_BASE_HREF_52);
    this._Location_54 = new import51.Location(this._LocationStrategy_53);
    this._ErrorLogService_55 = new import52.ErrorLogService(this._NewRelicService_51,this._Location_54);
    this._NotificationService_56 = new import53.NotificationService();
    this._LoadingWheelService_57 = new import54.LoadingWheelService();
    this._ErrorHandler_58 = new import55.AngularErrorHandler(this._ErrorLogService_55,this._NotificationService_56,this.parent.get(import133.NgZone),this._WindowRef_50,this._LoadingWheelService_57,this);
    this._ApplicationInitStatus_59 = new import56.ApplicationInitStatus(this.parent.get(import56.APP_INITIALIZER,(null as any)));
    this._Testability_60 = new import57.Testability(this.parent.get(import133.NgZone));
    this._ApplicationRef__61 = new import58.ApplicationRef_(this.parent.get(import133.NgZone),this.parent.get(import159.Console),this,this._ErrorHandler_58,this,this._ApplicationInitStatus_59,this.parent.get(import57.TestabilityRegistry,(null as any)),this._Testability_60);
    this._NoPreloading_137 = new import107.NoPreloading();
    this._PreloadingStrategy_138 = this._NoPreloading_137;
    this._RouterPreloader_139 = new import107.RouterPreloader(this._Router_135,this._NgModuleFactoryLoader_132,this._Compiler_63,this,this._PreloadingStrategy_138);
    return this._SaraV2AppModule_47;
  }
  getInternal(token:any,notFoundResult:any):any {
    if ((token === import2.CommonModule)) { return this._CommonModule_0; }
    if ((token === import3.ApplicationModule)) { return this._ApplicationModule_1; }
    if ((token === import4.BrowserModule)) { return this._BrowserModule_2; }
    if ((token === import5.UpgradeModule)) { return this._UpgradeModule_3; }
    if ((token === import6.InternalFormsSharedModule)) { return this._InternalFormsSharedModule_4; }
    if ((token === import7.FormsModule)) { return this._FormsModule_5; }
    if ((token === import8.HttpModule)) { return this._HttpModule_6; }
    if ((token === import9.ROUTER_FORROOT_GUARD)) { return this._ROUTER_FORROOT_GUARD_7; }
    if ((token === import9.RouterModule)) { return this._RouterModule_8; }
    if ((token === import10.AuditRoutingModule)) { return this._AuditRoutingModule_9; }
    if ((token === import11.DatePickerModule)) { return this._DatePickerModule_10; }
    if ((token === import12.TranslateModule)) { return this._TranslateModule_11; }
    if ((token === import13.AuditModule)) { return this._AuditModule_12; }
    if ((token === import7.ReactiveFormsModule)) { return this._ReactiveFormsModule_13; }
    if ((token === import14.PickupPointFeeRoutingModule)) { return this._PickupPointFeeRoutingModule_14; }
    if ((token === import15.SharedModule)) { return this._SharedModule_15; }
    if ((token === import16.PickupPointFeeModule)) { return this._PickupPointFeeModule_16; }
    if ((token === import17.CoreModule)) { return this._CoreModule_17; }
    if ((token === import18.ContactRoutingModule)) { return this._ContactRoutingModule_18; }
    if ((token === import19.ContactModule)) { return this._ContactModule_19; }
    if ((token === import20.SampleRoutingModule)) { return this._SampleRoutingModule_20; }
    if ((token === import21.Sample2Module)) { return this._Sample2Module_21; }
    if ((token === import22.InternalErrorRoutingModule)) { return this._InternalErrorRoutingModule_22; }
    if ((token === import23.InternalErrorModule)) { return this._InternalErrorModule_23; }
    if ((token === import24.HomeRoutingModule)) { return this._HomeRoutingModule_24; }
    if ((token === import25.HomeModule)) { return this._HomeModule_25; }
    if ((token === import26.RestrictionsRoutingModule)) { return this._RestrictionsRoutingModule_26; }
    if ((token === import27.RestrictionsModule)) { return this._RestrictionsModule_27; }
    if ((token === import28.BookingRoutingModule)) { return this._BookingRoutingModule_28; }
    if ((token === import29.BookingModule)) { return this._BookingModule_29; }
    if ((token === import30.LogoutRoutingModule)) { return this._LogoutRoutingModule_30; }
    if ((token === import31.LogoutModule)) { return this._LogoutModule_31; }
    if ((token === import32.AdditionalRoutingModule)) { return this._AdditionalRoutingModule_32; }
    if ((token === import33.AdditionalModule)) { return this._AdditionalModule_33; }
    if ((token === import34.InsuranceRoutingModule)) { return this._InsuranceRoutingModule_34; }
    if ((token === import35.InsuranceModule)) { return this._InsuranceModule_35; }
    if ((token === import36.PointOfSaleRoutingModule)) { return this._PointOfSaleRoutingModule_36; }
    if ((token === import37.TextMaskModule)) { return this._TextMaskModule_37; }
    if ((token === import38.PointOfSaleModule)) { return this._PointOfSaleModule_38; }
    if ((token === import39.AdditionalPointRoutingModule)) { return this._AdditionalPointRoutingModule_39; }
    if ((token === import40.AdditionalPointModule)) { return this._AdditionalPointModule_40; }
    if ((token === import41.AgeRangeRoutingModule)) { return this._AgeRangeRoutingModule_41; }
    if ((token === import42.AgeRangeModule)) { return this._AgeRangeModule_42; }
    if ((token === import43.CarTemplateRoutingModule)) { return this._CarTemplateRoutingModule_43; }
    if ((token === import44.CarTemplateModule)) { return this._CarTemplateModule_44; }
    if ((token === import45.FeatureModule)) { return this._FeatureModule_45; }
    if ((token === import46.CookieModule)) { return this._CookieModule_46; }
    if ((token === import1.SaraV2AppModule)) { return this._SaraV2AppModule_47; }
    if ((token === import129.LOCALE_ID)) { return this._LOCALE_ID_48; }
    if ((token === import47.NgLocalization)) { return this._NgLocalization_49; }
    if ((token === import48.WindowRef)) { return this._WindowRef_50; }
    if ((token === import49.NewRelicService)) { return this._NewRelicService_51; }
    if ((token === import160.APP_BASE_HREF)) { return this._APP_BASE_HREF_52; }
    if ((token === import160.LocationStrategy)) { return this._LocationStrategy_53; }
    if ((token === import51.Location)) { return this._Location_54; }
    if ((token === import52.ErrorLogService)) { return this._ErrorLogService_55; }
    if ((token === import53.NotificationService)) { return this._NotificationService_56; }
    if ((token === import54.LoadingWheelService)) { return this._LoadingWheelService_57; }
    if ((token === import161.ErrorHandler)) { return this._ErrorHandler_58; }
    if ((token === import56.ApplicationInitStatus)) { return this._ApplicationInitStatus_59; }
    if ((token === import57.Testability)) { return this._Testability_60; }
    if ((token === import58.ApplicationRef_)) { return this._ApplicationRef__61; }
    if ((token === import58.ApplicationRef)) { return this._ApplicationRef_62; }
    if ((token === import59.Compiler)) { return this._Compiler_63; }
    if ((token === import130.APP_ID)) { return this._APP_ID_64; }
    if ((token === import162.DOCUMENT)) { return this._DOCUMENT_65; }
    if ((token === import60.HAMMER_GESTURE_CONFIG)) { return this._HAMMER_GESTURE_CONFIG_66; }
    if ((token === import61.EVENT_MANAGER_PLUGINS)) { return this._EVENT_MANAGER_PLUGINS_67; }
    if ((token === import61.EventManager)) { return this._EventManager_68; }
    if ((token === import62.DomSharedStylesHost)) { return this._DomSharedStylesHost_69; }
    if ((token === import163.AnimationDriver)) { return this._AnimationDriver_70; }
    if ((token === import63.DomRootRenderer)) { return this._DomRootRenderer_71; }
    if ((token === import58.NgProbeToken)) { return this._NgProbeToken_72; }
    if ((token === import164.RootRenderer)) { return this._RootRenderer_73; }
    if ((token === import64.DomSanitizer)) { return this._DomSanitizer_74; }
    if ((token === import165.Sanitizer)) { return this._Sanitizer_75; }
    if ((token === import65.AnimationQueue)) { return this._AnimationQueue_76; }
    if ((token === import66.ViewUtils)) { return this._ViewUtils_77; }
    if ((token === import166.IterableDiffers)) { return this._IterableDiffers_78; }
    if ((token === import167.KeyValueDiffers)) { return this._KeyValueDiffers_79; }
    if ((token === import62.SharedStylesHost)) { return this._SharedStylesHost_80; }
    if ((token === import67.Title)) { return this._Title_81; }
    if ((token === '$injector')) { return this.__injector_82; }
    if ((token === '$rootScope')) { return this.__rootScope_83; }
    if ((token === '$compile')) { return this.__compile_84; }
    if ((token === '$parse')) { return this.__parse_85; }
    if ((token === import68.RadioControlRegistry)) { return this._RadioControlRegistry_86; }
    if ((token === import69.BrowserXhr)) { return this._BrowserXhr_87; }
    if ((token === import70.ResponseOptions)) { return this._ResponseOptions_88; }
    if ((token === import168.XSRFStrategy)) { return this._XSRFStrategy_89; }
    if ((token === import71.XHRBackend)) { return this._XHRBackend_90; }
    if ((token === import72.RequestOptions)) { return this._RequestOptions_91; }
    if ((token === import169.Http)) { return this._Http_92; }
    if ((token === import170.ROUTES)) { return this._ROUTES_93; }
    if ((token === import73.CalendarConfig)) { return this._CalendarConfig_94; }
    if ((token === import74.FormBuilder)) { return this._FormBuilder_95; }
    if ((token === import75.AuthenticateUserService)) { return this._AuthenticateUserService_96; }
    if ((token === import76.TranslateStore)) { return this._TranslateStore_97; }
    if ((token === import171.TranslateLoader)) { return this._TranslateLoader_98; }
    if ((token === import77.TranslateCompiler)) { return this._TranslateCompiler_99; }
    if ((token === import78.TranslateParser)) { return this._TranslateParser_100; }
    if ((token === import79.MissingTranslationHandler)) { return this._MissingTranslationHandler_101; }
    if ((token === import80.USE_DEFAULT_LANG)) { return this._USE_DEFAULT_LANG_102; }
    if ((token === import80.USE_STORE)) { return this._USE_STORE_103; }
    if ((token === import80.TranslateService)) { return this._TranslateService_104; }
    if ((token === import81.ModalService)) { return this._ModalService_105; }
    if ((token === import82.CompanyServiceA2)) { return this._CompanyServiceA2_106; }
    if ((token === import83.COOKIE_OPTIONS)) { return this._COOKIE_OPTIONS_107; }
    if ((token === import83.CookieOptionsProvider)) { return this._CookieOptionsProvider_108; }
    if ((token === import172.CookieService)) { return this._CookieService_109; }
    if ((token === import84.GAService)) { return this._GAService_110; }
    if ((token === import85.SessionService)) { return this._SessionService_111; }
    if ((token === import86.SidebarService)) { return this._SidebarService_112; }
    if ((token === import87.InformationModalService)) { return this._InformationModalService_113; }
    if ((token === import88.LogoutService)) { return this._LogoutService_114; }
    if ((token === import89.BackgroundColorService)) { return this._BackgroundColorService_115; }
    if ((token === import90.ValidatorService)) { return this._ValidatorService_116; }
    if ((token === import91.FormModalService)) { return this._FormModalService_117; }
    if ((token === import92.ContractService)) { return this._ContractService_118; }
    if ((token === import93.GeoServiceA2)) { return this._GeoServiceA2_119; }
    if ((token === import94.VersionCheckService)) { return this._VersionCheckService_120; }
    if ((token === import95.AlfredA2Service)) { return this._AlfredA2Service_121; }
    if ((token === import96.GeoCodeService)) { return this._GeoCodeService_122; }
    if ((token === import97.NavigationService)) { return this._NavigationService_123; }
    if ((token === import98.EmailValidatorService)) { return this._EmailValidatorService_124; }
    if ((token === import99.LegalDocumentService)) { return this._LegalDocumentService_125; }
    if ((token === import100.ContractStatesService)) { return this._ContractStatesService_126; }
    if ((token === import173.LoggerService)) { return this._LoggerService_127; }
    if ((token === import102.HomeService)) { return this._HomeService_128; }
    if ((token === import103.PointOfSaleServiceA2)) { return this._PointOfSaleServiceA2_129; }
    if ((token === import104.UrlSerializer)) { return this._UrlSerializer_130; }
    if ((token === import105.RouterOutletMap)) { return this._RouterOutletMap_131; }
    if ((token === import174.NgModuleFactoryLoader)) { return this._NgModuleFactoryLoader_132; }
    if ((token === import9.ROUTER_CONFIGURATION)) { return this._ROUTER_CONFIGURATION_133; }
    if ((token === import175.UrlHandlingStrategy)) { return this._UrlHandlingStrategy_134; }
    if ((token === import157.Router)) { return this._Router_135; }
    if ((token === import176.ActivatedRoute)) { return this._ActivatedRoute_136; }
    if ((token === import107.NoPreloading)) { return this._NoPreloading_137; }
    if ((token === import107.PreloadingStrategy)) { return this._PreloadingStrategy_138; }
    if ((token === import107.RouterPreloader)) { return this._RouterPreloader_139; }
    if ((token === import107.PreloadAllModules)) { return this._PreloadAllModules_140; }
    if ((token === import9.ROUTER_INITIALIZER)) { return this._ROUTER_INITIALIZER_141; }
    if ((token === import130.APP_BOOTSTRAP_LISTENER)) { return this._APP_BOOTSTRAP_LISTENER_142; }
    return notFoundResult;
  }
  destroyInternal():void {
    this._ApplicationRef__61.ngOnDestroy();
    this._RouterPreloader_139.ngOnDestroy();
  }
}
export const SaraV2AppModuleNgFactory:import0.NgModuleFactory<import1.SaraV2AppModule> = new import0.NgModuleFactory(SaraV2AppModuleInjector,import1.SaraV2AppModule);


// WEBPACK FOOTER //
// ./aot/public/upgrade/saraV2_app.ngfactory.ts